import { BuildFormArgs, BuildFormReturn } from './model';

export const buildForm = ({
  fields,
  domOwner,
}: BuildFormArgs): BuildFormReturn => {
  if (!fields) {
    return {};
  }

  return fields.reduce((finalResult, value) => {
    const { secretName, envVarName } = value;
    const formValue = value.envVarName === 'SFTP_USER' ? `ip-${domOwner}` : '';

    const label = secretName || envVarName;
    finalResult[label] = formValue;

    return finalResult;
  }, {});
};
